/* eslint-disable import/prefer-default-export */
const toDate = value => (value ? new Date(value) : null);

const STATUS_LABELS = {
    archived: 'Archived',
    abandoned: 'Abandoned',
    resulted: 'Results',
    closed: 'Closed',
    entered: 'Entered',
    upcoming: 'Coming Soon'
};

export const isArchived = sweep => {
    const event = (sweep && sweep.event) || {};
    return event.status === 'archived';
};

const getVariant = (sweep, hasEntered) => {
    const now = new Date();
    const event = sweep.event || {};
    const openDate = toDate(sweep.openDate);
    const closeDate = toDate(sweep.closeDate);
    const startDate = toDate(event.startDate);

    if (event.status === 'archived') {
        return 'archived';
    }
    if (event.status === 'abandoned') {
        return 'abandoned';
    }
    if ((event.winningSelections || []).length > 0) {
        return 'resulted';
    }
    if (closeDate && now >= closeDate) {
        return 'closed';
    }
    if (startDate && now > startDate && hasEntered) {
        return 'entered';
    }
    if (
        sweep.status === 'open' &&
        openDate &&
        closeDate &&
        now >= openDate &&
        now < closeDate
    ) {
        return 'open';
    }
    if (openDate && now < openDate) {
        return 'upcoming';
    }
    return 'default';
};

export const getSweepStatusInfo = (sweep, hasEntered) => {
    const variant = getVariant(sweep, hasEntered);

    let label;
    if (variant === 'open') {
        label = hasEntered ? 'Entered' : 'Open';
    } else if (variant === 'default') {
        label = sweep.status || 'Unknown';
    } else {
        label = STATUS_LABELS[variant];
    }

    let cta;
    if (hasEntered) {
        cta = { text: 'VIEW SWEEPSTAKE', suffix: '/entered' };
    } else if (variant === 'open') {
        cta = { text: 'ENTER SWEEPSTAKE', suffix: '' };
    } else {
        cta = { text: 'VIEW DETAILS', suffix: '' };
    }

    return {
        label,
        showCountdown: variant === 'open' || variant === 'entered',
        cta
    };
};
